import React from 'react';
import { useParams } from 'react-router-dom';
import ProjectsCarrousel from 'components/artectum/slides/featured-projects-artectum';
import ProductDetails from 'components/artectum/product-details/ProductDetails';
import FeaturedItem from 'components/artectum/slides/featured-product-artectum';

const Product_Details = () => {
    const { id } = useParams();

    return (
        <>
            <ProductDetails productId={id} />
            {/* <FeaturedItem customClass="py-5" /> */}
            <ProjectsCarrousel sectionClass="py-5" />
        </>
    );
}

export default Product_Details;